<template>
  <div class="real-message-tree">
    <div class="content" v-for="item in dataset" :key="item.id">
      <div class="item parent" :class="{'active': item.id === select}" @click="check(item)">
        <div v-if="item.children" class="arrow tableIconHover">
          <i  class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': item.open}"></i>
        </div>
        <i class="icon iconfont pic" :class="{[item.icon]: true}" :style="{'color': item.color}"></i>
        <span>{{item.label}}</span>
        <div class="count" v-if="item.count > 0 && !item.open">{{item.count > 99 ? '99+' : item.count}}</div>
      </div>
      <el-collapse-transition>
        <div v-if="item.open">
          <div class="content" v-for="(temp) in item.children" :key="temp.id" >
            <div class="item" :class="{'active': temp.id === select, 'parent': temp.children}" @click="check(temp)">
              <div v-if="temp.children" class="arrow tableIconHover">
                <i  class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': temp.open}"></i>
              </div>
              <i class="icon iconfont pic" :class="{[temp.icon]: true}" :style="{'color': temp.color}"></i>
              <span>{{temp.label}}</span>
              <div class="count" v-if="temp.count > 0 && !temp.open">{{temp.count > 99 ? '99+' : temp.count}}</div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
  props: ['numberCount', 'selectId'],
  data() {
    return {
      dataset: [{
        label: '全部通知',
        labelKey: '全部',
        value: 0,
        icon: 'iconicon_all_messages',
        color: '#1EB388',
        count: 0,
        id: 1
      }, {
        label: '项目',
        value: 100,
        icon: 'iconicon_team_project',
        count: '',
        color: '#2682FF',
        id: 2,
        open: false,
        children: [{
          label: '项目相关',
          value: 1,
          icon: '',
          count: 0,
          id: 3
        },{
          label: '清单相关',
          value: 2,
          icon: '',
          count: 0,
          id: 4
        },{
          label: '任务相关',
          value: 3,
          icon: '',
          count: 0,
          id: 5
        }]
      },{
        label: '任务',
        value: 101,
        icon: 'iconicon_task_message',
        count: '',
        color: '#6464FF',
        id: 6,
        open: false,
        children: [{
          label: '新的任务',
          value: 4,
          icon: '',
          count: 0,
          id: 7
        },{
          label: '任务状态',
          value: 5,
          icon: '',
          count: 0,
          id: 8
        },{
          label: '任务修改',
          value: 6,
          icon: '',
          count: 0,
          id: 9
        }]
      }, {
        label: '评论和@',
        value: 7,
        icon: 'iconicon_comment2',
        count: 0,
        color: '#2682FF',
        id: 10
      }],
      select: 1
    }
  },
  watch: {
    numberCount: {
      handler() {
        for(let key in this.numberCount) {
          this.tree(key, this.numberCount[key])
        }
        this.dataset.find(res => {
          if(res.id === 2 || res.id === 6){
            res.count = res.children.reduce((pre, n) => pre + n.count,0)
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // if(this.selectId) {
    //   this.treeCheck(this.selectId)
    // }
  },
  methods: {
    check(item) {
      if(item.children) {
        this.$set(item, 'open', !item.open)
      }
      this.select = item.id
      this.$emit('change', item.value, item.label)
    },
    tree(label, count) {
      let fn = (data) => {
        data.find(res => {
          if(res.label === label || res.labelKey === label) {
            res.count = count
            return true
          }
          if(res.children) {
            fn(res.children)
          }
        })
      }
      fn(this.dataset)
    },
    treeCheck(id) {
      if(!id) return
      let fn = (data) => {
        data.find(res => {
          console.log(res.id, id)
          if(res.id === Number(id)) {
            this.check(res)
          }
          if(res.children) {
            fn(res.children)
          }
        })
      }
      fn(this.dataset)
    }
  }
}
</script>
<style lang="scss">
.real-message-tree {
  width: 256px;
  height: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
  border-right: 1px solid rgba(32, 32, 32, 0.08);
  overflow-x: hidden;
  overflow: overlay;
  .content {
    overflow: hidden;
    .item {
      height: 48px;
      display: flex;
      align-items: center;
      cursor: pointer;
      border-radius: 4px;
      padding-left: 43px;
      position: relative;
      font-size: 14px;
      font-weight: 400;
      color: initial;
      .pic {
        margin-right: 18px;
        width: 16px;
        height: 16px;
      }
      &:hover {
        background-color: rgba(32, 32, 32, 0.04);
      }
      &:active {
        background-color: rgba(32, 32, 32, 0.08);
      }
      .arrow {
        color: rgba(32, 32, 32, 0.24);
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translate(0, -50%);
        i {
          transition: all .3s;
        }
      }
      .count {
        height: 20px;
        padding: 0 6px;
        text-align: center;
        line-height: 20px;
        background: linear-gradient(270deg, #6B97CF 0%, #456FB3 100%);
        border-radius: 10px;
        font-size: 12px;
        color: #fff;
        position: absolute;
        top: 50%;
        transform: translate(0,-50%);
        right: 24px;
        flex-shrink: 0;
        min-width: 20px;
        box-sizing: border-box;
      }
      &.active {
        background-color: rgba(32, 32, 32, 0.08);
      }
      &.parent {
        font-size: 16px;
        i {
          line-height: 1;
        }
      }
    }
  }
}
</style>
